import React from 'react'
import { useParams } from 'react-router-dom';

const FGDetail = () => {
    const { fgId } = useParams();
  return (
    <div>FGDetail</div>
  )
}

export default FGDetail